import {AxiosResponse} from 'axios';
import authenticatedApi from '../../@template/services/auth/authApi/authenticatedApi';
import {externalApiConfig} from '../../config';
import {ParticipantSessionView} from '../../types/views/ParticipantSessionView';
import {SearchRequest} from '../../types/common/SearchRequest';
import {SessionSearchRequest} from '../../types/requests/SessionSearchRequest';
import {PagedEntityListOfParticipantSessionView} from '../../types/views/PagedEntityListOfParticipantSessionView';
import {
    SESSION_SEARCH,
    sessionLoadError,
    sessionLoadSuccess,
    SESSIONS,
    sessionSearchError,
    sessionSearchSuccess
} from './Actions';
import {all, call, put, takeEvery} from '@redux-saga/core/effects';
import {parseErrorInfo} from '../../@template/helpers/errors';
import {PayloadAction} from '@reduxjs/toolkit';


export function* LoadSession(id: string) {
    console.log('SAGA - sessionSaga - LoadSession');
    try {
        const res: AxiosResponse = yield authenticatedApi.request({
            baseURL: externalApiConfig.Url,
            method: 'GET',
            url: `${externalApiConfig.Paths.session}/${id}`,
        });
        const session: ParticipantSessionView = ParticipantSessionView.fromJS(res.data);
        yield put(sessionLoadSuccess(session));
    } catch (err) {
        yield put(sessionLoadError(parseErrorInfo(err)));
    }
}

export function* SearchSessions({ page, pageSize, searchParams, sortBy, sortDirection }: SearchRequest<SessionSearchRequest>) {
    console.log('SAGA - sessionSaga - SearchSessions');
    try {
        const res: AxiosResponse = yield authenticatedApi.request({
            baseURL: externalApiConfig.Url,
            method: 'PUT',
            url: `${externalApiConfig.Paths.session}/search?page=${page}&page_size=${pageSize}&sort=${sortBy}&order=${sortDirection}`,
            data: searchParams
        });
        const results: PagedEntityListOfParticipantSessionView = PagedEntityListOfParticipantSessionView.fromJS(res.data);
        yield put(sessionSearchSuccess(results));
    } catch (err) {
        yield put(sessionSearchError(parseErrorInfo(err)));
    }
}

export function* watchLoadSession(){
    yield takeEvery(SESSIONS.LOAD, ({ payload } : PayloadAction<string>) => LoadSession(payload));
}

export function* watchRefreshSession(){
    yield takeEvery(SESSIONS.REFRESH, ({ payload } : PayloadAction<string>) => LoadSession(payload));
}

export function* watchSearchSessions(){
    yield takeEvery(SESSION_SEARCH.LOAD, ({ payload } : PayloadAction<SearchRequest<SessionSearchRequest>>) => SearchSessions(payload));
}

export default function* sessionSaga() {
    yield all ([
        call(watchRefreshSession),
        call(watchLoadSession),
        call(watchSearchSessions),
    ])
}